// AverageInvalidUePDF.js
import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Styles du PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 40,
  },
  leftHeader: { flex: 1 },
  rightHeader: { flex: 1, textAlign: "right" },
  title: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
  },
  tableContainer: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#eeeeee",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    fontWeight: "bold",
  },
  tableCell: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
  },
  oddRow: { backgroundColor: "#f9f9f9" },
});

// Composant PDF pour les UE invalidées
const AverageInvalidUePDF = ({ data }) => {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* ================== HEADER ================== */}
        <View style={styles.headerRow}>
          <View style={styles.leftHeader}>
            <Text>UNIVERSITE DES SCIENCES, DES TECHNIQUES</Text>
            <Text>ET DES TECHNOLOGIES DE BAMAKO : USTTB</Text>
            <Text>FACULTE DE MEDECINE ET D'ODONTO-STOMATOLOGIE : FMOS</Text>
          </View>
          <View style={styles.rightHeader}>
            <Text>République du Mali</Text>
            <Text>Un Peuple - Un But - Une Foi</Text>
          </View>
        </View>

        <Text style={styles.title}>Liste des Moyennes (UE invalidée)</Text>

        {/* ================== TABLE ================== */}
        <View style={styles.tableContainer}>
          {/* Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCell, { flex: 2 }]}>Numéro étudiant</Text>
            <Text style={[styles.tableCell, { flex: 2 }]}>Étudiant</Text>
            <Text style={[styles.tableCell, { flex: 2 }]}>UE</Text>
            <Text style={[styles.tableCell, { flex: 1, textAlign: "center" }]}>Moyenne</Text>
            <Text style={[styles.tableCell, { flex: 0.7, textAlign: "center" }]}>Validée</Text>
          </View>

          {/* Rows */}
          {data.map((student, idxStudent) =>
            Object.values(student.ues || {})
              .filter((ue) => !ue.ue_valid)
              .map((ue, idxUe) => (
                <View
                  style={[
                    styles.tableRow,
                    (idxStudent + idxUe) % 2 === 1 ? styles.oddRow : null,
                  ]}
                  key={`${student.student_id}-${ue.ue_id}`}
                >
                  <Text style={[styles.tableCell, { flex: 2 }]}>{student.student_number}</Text>
                  <Text style={[styles.tableCell, { flex: 2 }]}>
                    {student.first_name} {student.last_name}
                  </Text>
                  <Text style={[styles.tableCell, { flex: 2 }]}>{ue.ue_title}</Text>
                  <Text style={[styles.tableCell, { flex: 1, textAlign: "center" }]}>{ue.ue_note}</Text>
                  <Text style={[styles.tableCell, { flex: 0.7, textAlign: "center" }]}>
                    {ue.ue_valid ? "Oui" : "Non"}
                  </Text>
                </View>
              ))
          )}
        </View>
      </Page>
    </Document>
  );
};

export default AverageInvalidUePDF;